module.exports = __webpack_public_path__ + "assets/img/gutters-2.c340c60c.jpg";